var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature Icon with circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.0449 25.9061C39.0449 29.7202 35.953 32.8121 32.1388 32.8121C28.3247 32.8121 25.2328 29.7202 25.2328 25.9061C25.2328 22.0919 28.3247 19 32.1388 19C35.953 19 39.0449 22.0919 39.0449 25.9061Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.6506 37.2222L34.6719 44.9996H44.2752C44.2752 39.6433 39.9419 35.3005 34.5892 35.2831L32.6506 37.2222Z",
    fill: "#3869E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.7422 37.243L29.7821 35.2829H29.7172C24.3504 35.2829 20 39.6333 20 45.0001H29.8333L31.7422 37.243Z",
    fill: "#3869E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.b0d55919bda550293772875fd74adcce.svg";
export { ForwardRef as ReactComponent };